import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Tmd.dtos';

import {
    ACTION_INSTITUTIONITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE,
    ACTION_INSTITUTIONITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE
} from '../../actions/pages/institutionItemsPage';


export interface IInstitutionItemsPageState {
    editModalOpen: boolean;
    collectionInstanceId: number;
    name: string;
    description: string;
    createVersionModalOpen: boolean;
    institutionItem: Dtos.InstitutionItem
}

const initialState: IInstitutionItemsPageState = {
    editModalOpen: false,
    collectionInstanceId: null,
    name: "",
    description: "",
    createVersionModalOpen: false,
    institutionItem: null
};


function setEditModalViewState(state: IInstitutionItemsPageState, open: boolean, collectionInstanceId: number, name: string, description: string): IInstitutionItemsPageState {
    const newState: IInstitutionItemsPageState = update(state, {
        editModalOpen: {
            $set: open
        },
        collectionInstanceId: {
            $set: collectionInstanceId
        },
        name: {
            $set: name
        },
        description: {
            $set: description
        }
    });
    return newState;
}

function setCreateVersionModalViewState(state: IInstitutionItemsPageState, open: boolean, institutionItem: Dtos.InstitutionItem): IInstitutionItemsPageState {
    const newState: IInstitutionItemsPageState = update(state, {
        createVersionModalOpen: {
            $set: open
        },
        institutionItem: {
            $set: institutionItem
        }
    });
    return newState;
}

const InstitutionItemsPageReducer: Reducer<IInstitutionItemsPageState> = (state: IInstitutionItemsPageState = initialState, action) => { 
    switch (action.type) {
        case ACTION_INSTITUTIONITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE:
            return setEditModalViewState(state, action.open, action.collectionInstanceId, action.name, action.description);
        case ACTION_INSTITUTIONITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE:
            return setCreateVersionModalViewState(state, action.open, action.institutionItem);
    }

    return state;
}

export default InstitutionItemsPageReducer;